import { ETypographyIntents } from '@src/typings';
import { Avatar as AntdAvatar } from 'antd';
import React from 'react';
import { HiUser } from 'react-icons/hi2';
import { withTheme } from '../ThemeProvider';
import { Typography } from '../Typography';
import { StyledAvatar, StyledAvatarContainer } from './styles';
import { AvatarProps } from './types';

const typoIntent = {
    small: ETypographyIntents.Badge,
    medium: ETypographyIntents.Regular,
    large: ETypographyIntents.Action,
    48: ETypographyIntents.H2,
};

export const AvatarGroup = AntdAvatar.Group;

const AvatarComponent: React.FC<AvatarProps> = ({
    text,
    className,
    textClassName,
    ...props
}: AvatarProps) => {
    return (
        <StyledAvatarContainer>
            <StyledAvatar
                {...(!props.children
                    ? { icon: <HiUser className="avatar-icon" /> }
                    : '')}
                className={className}
                {...props}
            />
            {text && (
                <Typography
                    className={`ml-1 ${textClassName || ''}`}
                    intent={
                        typoIntent[
                            (props.size as keyof typeof typoIntent) || 'medium'
                        ]
                    }
                >
                    {text}
                </Typography>
            )}
        </StyledAvatarContainer>
    );
};

AvatarComponent.displayName = 'AvatarComponent';

export const Avatar = withTheme(AvatarComponent);
